module.exports = __webpack_public_path__ + "static/img/brand_1@2x.a8e4d75f.png";